import React from "react";
import {Button, Col, Row, Space} from "antd";
import {
    FacebookOutlined,
    InstagramOutlined,
    TwitterOutlined,
    PhoneOutlined,
    WhatsAppOutlined,
    MailOutlined,
    HomeOutlined
}
from "@ant-design/icons";
import data from "./data";
import ReactGA from "react-ga";

const Footer : React.FC = () => {
    return (
        <footer id={"contact"} className={"public-footer"}>
            <div className={"public-container"}>
                <Row gutter={[300, 50]}>
                    <Col lg={12} md={12} sm={24} xs={24}>
                       <div className={"section-heading"}>
                           <h2>{data.id.title}</h2>
                           <p>{data.id.subTitle}</p>
                       </div>
                        <div className={"social-media"}>
                            <Space size={"large"}>
                                <a
                                    href={"https://www.facebook.com/wasdlabs"}
                                    target={"_blank"}
                                    rel={"noreferrer"}
                                    onClick={() => ReactGA.event({category : "Social_Media", action : "clicked", label : "facebook_footer" })}
                                >
                                    <FacebookOutlined />
                                </a>
                                <a
                                    href={"https://www.instagram.com/wasdlabs/"}
                                    target={"_blank"}
                                    rel={"noreferrer"}
                                    onClick={() => ReactGA.event({category : "Social_Media", action : "clicked", label : "instagram_footer" })}
                                >
                                    <InstagramOutlined />
                                </a>
                                <a
                                    href={"https://www.facebook.com/wasdlabs"}
                                    target={"_blank"}
                                    rel={"noreferrer"}
                                    onClick={() => ReactGA.event({category : "Social_Media", action : "clicked", label : "twitter_footer" })}
                                >
                                    <TwitterOutlined />
                                </a>
                            </Space>
                        </div>
                    </Col>
                    <Col lg={12} md={12} sm={24} xs={24}>
                        <div className={"contact"}>
                            <div className={"phone"}>
                                <Space size={"middle"}>
                                    <PhoneOutlined />
                                    +6285 656 284641 (Ahyar Muawwal)
                                </Space>
                                <Space size={"middle"}>
                                    <PhoneOutlined />
                                    +6281 355 549666 (Zulkarnaim)
                                </Space>
                            </div>
                            <div className={"wa"}>
                                <Space size={"middle"}>
                                    <WhatsAppOutlined />
                                    +6285 656 284641 (Ahyar Muawwal)
                                </Space>
                                <Space size={"middle"}>
                                    <WhatsAppOutlined />
                                    +6281 355 549666 (Zulkarnaim)
                                </Space>
                            </div>
                            <div className={"email"}>
                                <Space size={"middle"}>
                                    <MailOutlined />
                                    hello@wasdlabs.com
                                </Space>
                            </div>
                            <div className={"address"}>
                                <Space align={"start"} size={"middle"}>
                                    <HomeOutlined />
                                    BTN Tamarunang Indah I, Blok D2 No 1,
                                    Tamarunang, Gowa, Sulawesi Selatan
                                    92118
                                </Space>
                            </div>
                            <div className={"footer-buttons"}>
                                <Space size={"middle"}>
                                    <Button
                                        size={"large"}
                                        ghost={true}
                                        href={"https://goo.gl/maps/V6XJvBNtSW1va8Sa7"}
                                        target={"_blank"}
                                        rel={"noreferrer"}
                                        onClick={() => ReactGA.event({category : "Contact", action : "clicked", label : "get_direction" })}
                                    >
                                        Get Direction
                                    </Button>
                                    <Button
                                        size={"large"}
                                        ghost={true}
                                        href={"tel:+6285656284641"}
                                        target={"_blank"}
                                        rel={"noreferrer"}
                                        onClick={() => ReactGA.event({category : "Contact", action : "clicked", label : "call_now" })}
                                    >
                                        Call Now
                                    </Button>
                                    <Button
                                        size={"large"}
                                        ghost={true}
                                        href={"https://wa.me/6285656284641"}
                                        target={"_blank"}
                                        rel={"noreferrer"}
                                        onClick={() => ReactGA.event({category : "Contact", action : "clicked", label : "chat" })}
                                    >
                                        Chat
                                    </Button>
                                </Space>
                            </div>
                        </div>
                    </Col>
                </Row>
                <p>Made with love by WASD Labs Developer Unit</p>
            </div>
        </footer>
    )
}

export default Footer;